// extracted by mini-css-extract-plugin
module.exports = {"container":"eC5uVTzhItdLHs1R6sQhL"};